<template>
    <div id="upload_complete">
        <div class="content">
            <div class="container">
                <h2 class="title2">旅平險要保書上傳成功</h2>
                <p>親愛的 <span class="tlf_r_f1" id="assuredName">{{ maskName(applicantName) }}</span> 先生/小姐  您好:</p><br/>
                <p>要保序號 {{applicationNo}} 要保書已上傳成功，
                    於 {{uploadTime}}共傳 {{fileCount}} 個檔案，
                    核保資料檢查作業需要2~3個工作天，
                    請留意您的手機簡訊＆Email信箱以接收核保結果通知，謝謝。</p>
            </div>
        </div>
        <div class="btnArea">
            <div class="anotherBtn">
                <router-link :to="'/'" class="btn">回到首頁</router-link>
                <router-link :to="'/upload'" class="btn confirm">繼續上傳</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import {popUp} from "@/utils/popUp";
import {onMounted, ref} from "vue";
import gtm from "@/utils/gtmDataLayer";
import Swal from "sweetalert2";
import {useRouter} from "vue-router";

export default {
    name: "upload_complete",
    setup(){
        const router = useRouter();

        const uploadStorage = JSON.parse(sessionStorage.getItem("uploadStorage"));

        const applicantName = ref("");
        const applicationNo = ref("");
        const fileCount = ref(0);
        const uploadTime = ref("");


        const  loadUploadStorage = () => {
            if(uploadStorage != null){
                applicantName.value = uploadStorage.applicantName;
                applicationNo.value = uploadStorage.applicationNo;
                fileCount.value = uploadStorage.fileCount;
                uploadTime.value = moment(uploadStorage.uploadTime).format('YYYY[年]MM[月]DD[日] HH[時]mm[分]');
            }else{
                Swal.fire({
                    title: "尚未完成要保書上傳",
                    showCloseButton: true,
                    html: '<img src="successmark.svg" alt="success">' +
                        '<p>親愛的客戶您好，請先進行要保書上傳</p>'
                }).then(() => {
                    router.push('/upload');
                });
            }
        }
        const maskName = (name)=>{
            const char = name.toString().split('');
            let maskName = "";
            char.forEach((c,i) =>{
                if(i === 1){
                    maskName = maskName + 'Ｏ'
                }else{
                    maskName = maskName + c;
                }
            });
            return maskName;
        }

        loadUploadStorage();

        onMounted(()=>{
            popUp();//公告系統
            gtm.pageViewEvent();//新增pageViewEvent
        })

        return{
            applicantName,applicationNo,fileCount,uploadTime,
            maskName
        }

    }
}
</script>

<style lang="scss">
#upload_complete {
    .content{
        margin: 8em auto 60px;
    }
}

</style>